import { type FC, memo, useMemo } from 'react'
import styled from 'styled-components'

import UnderlineTabs from 'components/Button/UnderlineTabs'
import { FlexDivRowCentered } from 'components/layout/flex'
import { setPreferences } from 'state/futures/reducer'
import { selectSelectedChart } from 'state/futures/selectors'
import { useAppDispatch, useAppSelector } from 'state/hooks'

import { CHART_TOGGLE_HEIGHT } from '../styles'

enum ChartsTab {
	PRICE = 'price',
	FUNDING = 'funding',
	MARKET_DETAILS = 'market_details',
}

type ChartToggleProps = {
	className?: string
}

const ChartToggle: FC<ChartToggleProps> = memo(({ className }) => {
	const dispatch = useAppDispatch()
	const selectedChart = useAppSelector(selectSelectedChart)

	const CHART_OPTIONS = useMemo(
		() => [
			{
				name: ChartsTab.PRICE,
				label: 'Price',
				active: selectedChart === ChartsTab.PRICE,
				onClick: () => dispatch(setPreferences({ selectedChart: ChartsTab.PRICE })),
			},
			{
				name: ChartsTab.FUNDING,
				label: 'Funding',
				active: selectedChart === ChartsTab.FUNDING,
				onClick: () => dispatch(setPreferences({ selectedChart: ChartsTab.FUNDING })),
			},
			{
				name: ChartsTab.MARKET_DETAILS,
				label: 'Market Details',
				active: selectedChart === ChartsTab.MARKET_DETAILS,
				onClick: () => dispatch(setPreferences({ selectedChart: ChartsTab.MARKET_DETAILS })),
			},
		],
		[dispatch, selectedChart]
	)

	return (
		<Container columnGap="30px" className={className}>
			<TabButtonsContainer>
				<UnderlineTabs options={CHART_OPTIONS} />
			</TabButtonsContainer>
		</Container>
	)
})

const TabButtonsContainer = styled.div`
	display: flex;
	min-height: ${CHART_TOGGLE_HEIGHT}px;
	gap: 15px;

	& .title {
		font-size: 12px;
		text-transform: capitalize;
	}
`

const Container = styled(FlexDivRowCentered)`
	height: ${CHART_TOGGLE_HEIGHT}px;
	overflow-x: scroll;
`

export default ChartToggle
